import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  PinterestShareButton,
} from "react-share";
import {
  FaFacebookF,
  FaTwitter,
  FaPinterest,
  FaLinkedin,
} from "react-icons/fa";
import { useRouter } from "next/router";

const Index = () => {
  const router = useRouter();
  return (
    <div className="flex justify-center items-center gap-2">
      <span>Share On:</span>
      <div className="flex gap-2 justify-center items-center">
        <FacebookShareButton
          className="basis-1/5"
          url={`https://bungalowfinder.ca/${router.asPath}`}
        >
          <div
            style={{ backgroundColor: "#4267B2" }}
            className="basis-1/5 flex justify-center items-center p-1 rounded"
          >
            <FaFacebookF className="text-white text-xl" />
          </div>
        </FacebookShareButton>

        <TwitterShareButton
          className="basis-1/5"
          url={`https://bungalowfinder.ca/${router.asPath}`}
          title={"Main"}
        >
          <div
            style={{ backgroundColor: "#00acee" }}
            className="basis-1/5 flex justify-center p-1 rounded"
          >
            <FaTwitter className="text-white text-xl" />
          </div>
        </TwitterShareButton>

        <PinterestShareButton
          style={{ backgroundColor: "#E60023" }}
          className="basis-1/5"
          url={`https://bungalowfinder.ca/${router.asPath}`}
          media={"/images/bannerImg.webp"}
        >
          <div className="basis-1/5 flex justify-center p-1 rounded">
            <FaPinterest className="text-white text-xl" />
          </div>
        </PinterestShareButton>

        <LinkedinShareButton
          className="basis-1/5"
          url={`https://bungalowfinder.ca/${router.asPath}`}
        >
          <div
            style={{ backgroundColor: "#0077b5" }}
            className="basis-1/5 flex justify-center p-1 rounded"
          >
            <FaLinkedin className="text-white text-xl" />
          </div>
        </LinkedinShareButton>
      </div>
    </div>
  );
};

export default Index;
